import { get } from 'lodash';

const UNIT_SIZE = 20;

export const unitsSpacing = (options: {
	value: string;
	inputSize?: number;
	letterSizeMultiplicator?: number;
}): number => {
	const { value, inputSize, letterSizeMultiplicator } = options;
	const defaultWidth = 4.5;
	const leftSpacing = 28;

	// numbers letters width
	const letterWidth = {
		0: 10.06,
		1: 5.13,
		2: 9.2,
		3: 9.43,
		4: 10.07,
		5: 10.06,
		6: 10.17,
		7: 8.75,
		8: 10.1,
		9: 10.09,
	};

	const sum = value.split('').reduce((a, b) => {
		return (
			a + Number.parseFloat(get(letterWidth, b) || defaultWidth) * (letterSizeMultiplicator || 1)
		);
	}, 0);

	if (inputSize) {
		return sum + leftSpacing > inputSize - UNIT_SIZE ? inputSize - UNIT_SIZE : sum + leftSpacing;
	}

	return sum + leftSpacing;
};
